import { ResultValue } from './ResultValue';
import { IContext } from '../IContext';


/**
 * controller method return result type of json.
 * context type 'application/json'
 *
 * @export
 * @class JsonResult
 */
export class JsonResult extends ResultValue {
    constructor(private data: object) {
        super('application/json');
    }
    async sendValue(ctx: IContext) {
        ctx.type = this.contentType;
        ctx.body = this.data || {};
    }

                    static ρAnn(): any {
                        return {"name":"JsonResult"};
                    }
               }
